<template>
  <!-- PDF Content Here -->
  <div>
    <div class="row">
      <div class="col-6 pl-3 p-2">
        <span class="brand-logo"><b-img :src="appLogoImage" alt="logo" /></span>
      </div>
      <div class="col-6 text-right">
        WR1 CORP<br />
        Ground Floor, Saigon Port Building<br />
        3 Nguyen Tat Thanh, Ward 13, District 4, Ho Chi Minh City, Vietnam<br />
        Tel: (+84) 28 3943 5899 Website: wr1.com.vn<br />
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center"><h2>QUOTATION</h2></div>
    </div>
    <div class="row">
      <div class="col-6 pl-3 p-2">
        <h4>To:</h4>
        <div class="pl-4">
          Name: {{ quotation.customer_name }} <br />
          Company: {{ quotation.customer_company_name }}<br />
        </div>
        <h4>Detail:</h4>

        <div class="pl-4">Commodity: {{ quotation.commodity }} <br /></div>
        <div class="pl-4">Gross Weight: {{ quotation.trong_luong }} <br /></div>
        <div
          class="pl-4"
          v-if="
            quotation.service_type != 6 &&
            quotation.service_type != 5 &&
            quotation.service_type != 2
          "
        >
          Handled type:
          {{
            $Utils.CONSTANTS.HANDLED_TYPES[quotation.handled_type]
              ? $Utils.CONSTANTS.HANDLED_TYPES[quotation.handled_type].text
              : ""
          }}
          <br />
        </div>
        <div v-if="quotation.pol" class="pl-4">
          POL: {{ quotation.pol }} <br />
        </div>
        <div
          class="pl-4"
          v-if="quotation.pickup_region || quotation.other_pickup_region"
        >
          Pick up:
          {{
            this.regions.find((e) => e.code == quotation.pickup_region)
              ? this.regions.find((e) => e.code == quotation.pickup_region).text
              : null || quotation.other_pickup_region
          }}
        </div>
      </div>
      <div class="col-6 pl-3 p-2">
        <div class="pl-4 pt-2">
          Phone : {{ quotation.customer_phone }}<br />
          Email: {{ quotation.customer_email }} <br />
        </div>
        <div class="pl-4 pt-3">
          <div
            v-if="quotation.service_type != 6 && quotation.service_type != 5"
          >
            Term: {{ quotation.incoterms }} <br />
          </div>
          <div v-if="quotation.service_type == 2">
            Container type:
            {{
              this.cont_types.find((e) => e.id == quotation.cont_type)
                ? this.cont_types.find((e) => e.id == quotation.cont_type).text
                : null
            }}
            <br />
          </div>
          <div
            v-if="quotation.service_type != 5 && quotation.service_type != 2"
          >
            Volume (cbm): {{ quotation.so_khoi }} <br />
          </div>

          <div
            v-if="quotation.service_type != 5 && quotation.service_type != 2"
          >
            {{
              quotation.size_
                ? `Dimension:  ${
                    !quotation.size_.length_ || !!quotation.size_.length_
                      ? ""
                      : quotation.size_.length_ + "-"
                  }  ${
                    !quotation.size_.width_ || !!quotation.size_.width_
                      ? ""
                      : quotation.size_.width_ + "-"
                  }  ${
                    !quotation.size_.height_ || !!quotation.size_.height_
                      ? ""
                      : quotation.size_.height_
                  }`
                : ``
            }}
          </div>
          <div v-if="quotation.pol">POD: {{ quotation.pod }}</div>

          <div
            v-if="
              quotation.delivery_region || quotation.other_delivery_location
            "
          >
            Delivery:
            {{
              this.regions.find((e) => e.code == quotation.delivery_region)
                ? this.regions.find((e) => e.code == quotation.delivery_region)
                    .text
                : quotation.other_delivery_region || null
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <table class="table">
          <thead>
            <tr>
              <th v-if="quotation.carriers_name ? true : false">
                {{ quotation.service_type == 1 ? "Airline" : "Carrier" }}
              </th>
              <!-- <th v-if="quotation.pol ? true : false">
                {{ quotation.service_type == 1 ? "Origin" : "Or" }}
              </th>
              <th v-if="quotation.pod ? true : false">Destination</th> -->
              <th v-if="quotation.cut_off ? true : false">Cut off</th>

              <th v-if="quotation.fred ? true : false">Freq</th>
              <th v-if="quotation.transit_time ? true : false">Transit time</th>
              <th v-if="quotation.via ? true : false">Via</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-if="quotation.carriers_name ? true : false">
                {{ quotation.carriers_name }}
              </td>
              <!-- <td v-if="quotation.pol ? true : false">{{ quotation.pol }}</td>
              <td v-if="quotation.pod ? true : false">{{ quotation.pod }}</td> -->
              <th v-if="quotation.cut_off ? true : false">
                {{ quotation.cut_off }}
              </th>

              <td v-if="quotation.fred ? true : false">{{ quotation.fred }}</td>
              <td v-if="quotation.transit_time ? true : false">
                {{ quotation.transit_time }}
              </td>
              <td v-if="quotation.via ? true : false">
                {{ quotation.via }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="html2pdf__page-break1" />
    <div class="row">
      <div class="col-12 text-center">
        <table
          class="table-print"
          v-if="fee_types != null && unit_types != null"
        >
          <thead>
            <tr>
              <th>NO</th>
              <th>Description</th>
              <th>Unit</th>
              <th>Unit price</th>
              <th>Quantity</th>
              <th>Amount</th>
              <th>Currency</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody v-for="(c, idx) in costs" :key="c.id + c.idx">
            <tr>
              <td colspan="8">
                <h5>{{ idx + 1 }}. {{ c.name }}</h5>
              </td>
            </tr>
            <tr v-for="(i, index) in c.detail" :key="i.fee_type + index">
              <td class="text-center">
                <span v-if="i.checked">&#10003;</span>
              </td>
              <td>{{ fee_types.filter((k) => k.id == i.fee_type)[0].text }}</td>
              <td>{{ unit_types.filter((k) => k.id == i.unit)[0].text }}</td>
              <td class="text-right">{{ i.unit_price }}</td>
              <td class="text-right">{{ i.qty }}</td>
              <td class="text-right">
                {{
                  i.currency == "VND"
                    ? $Utils.formatMooney(
                        i.qty *
                          (i.unit_price + "")
                            .replace(/\./g, "")
                            .replace(/,/g, ""),
                        "vi-VN"
                      )
                    : $Utils.formatMooney(
                        i.qty * (i.unit_price + "").replace(/,/g, ""),
                        "en-US"
                      )
                }}
              </td>
              <td class="text-center">{{ i.currency }}</td>
              <td>{{ i.notes }}</td>
            </tr>
          </tbody>
          <tbody v-for="c in currencies" :key="c.id">
            <tr v-if="getTotal(c.id) > 0">
              <td colspan="6"></td>
              <td class="text-center">
                <b><span>Subtotal</span></b>
              </td>
              <td class="text-right">
                <b
                  >{{
                    c.id == "VND"
                      ? $Utils.formatMooney(getTotal(c.id), "vi-VN")
                      : $Utils.formatMooney(getTotal(c.id), "en-US")
                  }}
                  {{ c.id }}</b
                >
              </td>
            </tr>
            <tr v-if="getTotal(c.id) > 0">
              <td colspan="6"></td>
              <td class="text-center">
                <b><span>VAT</span></b>
              </td>
              <td class="text-right">
                <b>
                  {{
                    c.id == "VND"
                      ? $Utils.formatMooney(getTotalVAT(c.id), "vi-VN")
                      : $Utils.formatMooney(getTotalVAT(c.id), "en-US")
                  }}
                  {{ c.id }}</b
                >
              </td>
            </tr>
            <tr v-if="getTotal(c.id) > 0">
              <td colspan="6"></td>
              <td class="text-center">
                <b><span>Grand total</span></b>
              </td>
              <td class="text-right">
                <b>
                  {{
                    c.id == "VND"
                      ? $Utils.formatMooney(getTotalGrandTotal(c.id), "vi-VN")
                      : $Utils.formatMooney(getTotalGrandTotal(c.id), "en-US")
                  }}
                  {{ c.id }}</b
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12">
        <div class="row mt-1">
          <div class="col-12 mb-0 pb-0">
            <span class="mb-0 pb-0">Remark</span>
          </div>
          <div class="col-6 pl-3 pt-1">
            <span>
              Valid From:
              {{ moment(quotation.valid_from).format("DD/MM/YYYY") }}
            </span>
          </div>
          <div class="col-6 pl-3 pt-1">
            <span
              >To: {{ moment(quotation.valid_to).format("DD/MM/YYYY") }}</span
            >
          </div>
        </div>

        <div class="mt-1 d-flex">
          <span class="mr-1">Notes:</span>
          <div class="m-0" v-html="quotation.notes"></div>
        </div>
        <div class="mt-3">
          <span class="mr-1">Sale: {{ quotation.sale_name }}</span>
          <span class="mr-1 d-block">Phone: {{ quotation.sale_phone }}</span>

          <span class="mr-1 d-block">Email: {{ quotation.sale_email }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.table-print td {
  text-align: left;
}
.table-print th {
  text-align: center !important;
}
.table-print td,
.table-print th {
  border-bottom: 1px solid #333 !important;
  border-right: 1px solid #333 !important;
  padding: 4px 6px;
}
.table-print th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #2b938c;
  color: white;
}
</style>
<script>
import useJwt from "@/auth/jwt/useJwt";

import {
  BImg,
  BDropdown,
  BDropdownItem,
  BButton,
  BFormTextarea,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import VueHtml2pdf from "vue-html2pdf";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import moment from "moment";

export default {
  props: {
    cards: {},
    costs: { default: null },
    fee_types: { default: null },
    unit_types: { default: null },
    currencies: { default: null },
    request_quotation: { default: null },
    view_quotation: { default: null },
    regions: { default: [] },
    cont_types: { default: [] },
    service_types: { default: null },
    locations: { default: null },
  },
  components: {
    BImg,
    VueHtml2pdf,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormTextarea,
    BCardText,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    FeatherIcon,
  },
  data() {
    return {
      moment,
      appLogoImage: require("@/assets/images/logo/logo.png"),
      userData: JSON.parse(localStorage.getItem("userData")),
      quotation: {},
      locationsList: [],
    };
  },
  created() {},

  mounted() {
    if (this.request_quotation != null && this.service_types != null) {
      this.quotation = this.request_quotation;
      this.quotation.notes = this.view_quotation?.quotationNotes
        ? this.view_quotation?.quotationNotes.replaceAll("-", "<br/> -")
        : "";
    }
  },
  methods: {
    getTotal(currency) {
      var t = 0;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency) {
            t +=
              i.qty * (i.unit_price + "").replace(/\./g, "").replace(/,/g, "");
          }
        });
      });
      return t;
    },
    FN: function (value) {
      try {
        return (value + "")
          .replace(/[^0-9]/g, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      } catch (err) {
        return value;
      }
    },
    getTotalGrandTotal(currency) {
      var t = 0;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency) {
            if (currency == "USD") {
              t +=
                i.qty * (i.unit_price + "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "");
            } else {
              t +=
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "");
            }
          }
        });
      });
      return t;
    },
    getTotalVAT(currency) {
      var t = 0;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency) {
            if (currency == "USD") {
              t +=
                i.qty *
                (i.unit_price + "").replace(/,/g, "") *
                (i.vat ? i.vat / 100 : "");
            } else {
              t +=
                i.qty *
                (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                (i.vat ? i.vat / 100 : "");
            }
          }
        });
      });
      return t;
    },
  },
};
</script>